var uppercaseFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

export { uppercaseFirstLetter as default };
//# sourceMappingURL=uppercase-first-letter.js.map
